/*
 * @Author: shannyHuang
 * @Date: 2022-03-28 10:37:12
 * @LastEditors:
 * @LastEditTime: 2022-08-04 14:33:48
 * @FilePath: /wemeet-web-activity/src/components/HeadUpload/upload-hook.ts
 */
import { message } from '@tencent/tea-component';
import { useCallback, useEffect, useState } from 'react';
import { uploadToCos } from 'src/utils/upload-cos';

export const useUpload = (defaultUrl: string, onUploadComplete: (data: UploadResult) => void) => {
  const [file, setFile] = useState<File | null>(null);
  const [avatarImg, setAvatarImg] = useState(defaultUrl);
  const [status, setStatus] = useState<'error' | 'validating' | 'success' | undefined>(
    defaultUrl ? 'success' : undefined,
  );
  const [percent, setPercent] = useState(0);

  const handleFail = useCallback(() => {
    if (!onUploadComplete) return;
    onUploadComplete({
      url: '',
      cosId: '',
    });
  }, [onUploadComplete]);

  const beforeUpload = useCallback(
    (file: File, fileList?: File[], isAccepted = true, reasons?: any[]) => {
      if (!isAccepted) {
        console.log(fileList, reasons);
        setStatus('error');
        handleFail();
        return Promise.reject();
      }
      return uploadToCos(file).then(
        (data: any) => {
          const { cosId } = data;
          const windowURL = window.URL || window.webkitURL; // 兼容操作
          const dataURl = windowURL.createObjectURL(file);
          setAvatarImg(dataURl);
          setFile(file);
          setStatus('success');
          onUploadComplete({
            url: dataURl,
            cosId,
          });
          return { url: dataURl, cosId };
        },
        (err) => {
          console.log(err);
          message.error({ content: '请检查您的网络' });
          handleFail();
          return Promise.reject(err);
        },
      );
    },
    [onUploadComplete],
  );

  const handleAbort = useCallback(() => {
    setFile(null);
    setStatus(undefined);
    setPercent(0);
    handleFail();
    setAvatarImg(defaultUrl);
  }, []);

  useEffect(() => {
    setAvatarImg(defaultUrl);
  }, [defaultUrl]);

  return { avatarImg, status, percent, file, beforeUpload, handleAbort };
};

export interface UploadResult {
  url: string;
  cosId: string;
}
